const update  = async ({
  set,
  get,
  opts: value,
}) => {
  set({ isFetching: true });
};

export default update;
